<template>
  <div class="accueil-container text-center mt-5">
    <h1>Bienvenue, {{ userName }} !</h1>
    <div class="app-buttons mt-4">
        <b-button
            v-for="btn in buttons"
            :key="btn.label"
            variant="primary"
            class="app-button"
            @click="$router.push(btn.to)"
          >
          {{ btn.label }}
        </b-button>
      </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const userName = ref('Utilisateur');
onMounted(() => {
  try {
    const u = JSON.parse(localStorage.getItem('user'));
    if (u?.name) userName.value = u.name;
  } catch {
    console.error('Impossible de parser l\'utilisateur depuis le localStorage :');
  }
});

// Liste de vos boutons d'appli
const buttons = [
  { label: 'Interventions',       to: '/interventions' },
  { label: 'Photos',       to: '/photos' },
  { label: 'Tâches',       to: '/tasks' },
  // { label: 'Documentation',       to: '/documentation' },
  { label: 'Documentation mb',       to: '/docs' },
  // { label: 'Admin Documentation', to: '/admin/docs' },
  { label: 'Logs Système',       to: '/logs' },
  { label: 'Temps d\'Intervention',       to: '/intervention-time' },
  
];
</script>

<style scoped>
.accueil-container {
  max-width: 600px;
  margin: 0 auto;
  /* 1rem de chaque côté, ajustez à votre goût */
  padding: 0 1rem;
}

/* GRID RESPONSIVE pour les boutons */
.app-buttons {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 1rem;
  justify-items: center;
  align-items: start;
}

/* Chaque bouton prend toute la largeur de sa cellule */
.app-button {
  width: 100%;
  white-space: nowrap;       
  text-overflow: ellipsis;    
  overflow: hidden;
  padding: 0.5rem 0;
}

/* Ajustements mobiles si nécessaire */
@media (max-width: 480px) {
  .app-buttons {
    grid-template-columns: repeat(2, 1fr);  /* toujours 2 colonnes mini */
  }
}
</style>
